export default __webpack_public_path__ + "static/media/palette_knife_blocks_small.5045a962.jpg";